import { useQuery } from 'react-query';
import { GetGlobalSettingByGroupAndKeyResp } from './types';
import { getGlobalSettingByGroupAndKey } from './requests';

export const useGetGlobalSettingByGroupAndKey = ({
    group,
    key,
    refetchOnMount = false,
}: {
  key: string;
  group: string;
  refetchOnMount?: boolean;
}) => {
    const query = useQuery<
    GetGlobalSettingByGroupAndKeyResp
  >({
      queryKey: ['getGlobalSettingByGroupAndKey', group, key],
      queryFn: () => getGlobalSettingByGroupAndKey({ group, key }).then(({ data }) => data),
      refetchOnWindowFocus: false,
      refetchOnMount,
  });

    return query;
};
